import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Body2, Checkbox } from "@activecollab/components";
import PropTypes from "prop-types";
import { getValidMembers } from "./TeamPicker";

export const TeamOption = ({ name, onClick, selected, members, ids, hideAvailable }) => {
  const { t } = useTranslation();

  const selectedMemberCount = useMemo(() => {
    return members.filter((member) => selected.includes(member)).length;
  }, [members, selected]);

  const validMembers = getValidMembers(members, ids);

  const mixed = useMemo(
    () => selectedMemberCount > 0 && selectedMemberCount < validMembers.length,
    [validMembers.length, selectedMemberCount]
  );
  const checked = useMemo(
    () => selectedMemberCount > 0 && selectedMemberCount === validMembers.length,
    [validMembers.length, selectedMemberCount]
  );

  const handleClick = useCallback(() => {
    if (validMembers.length === selectedMemberCount) {
      const updatedSelection = selected.filter((member) => !validMembers.includes(member));
      onClick(updatedSelection);
    } else {
      const updatedSelection = [...new Set([...selected, ...validMembers])];
      onClick(updatedSelection);
    }
  }, [validMembers, selectedMemberCount, selected, onClick]);

  return (
    <div
      className="tw-flex tw-cursor-pointer tw-w-full tw-gap-2"
      onClick={handleClick}
    >
      <Body2 className="tw-truncate tw-shrink tw-min-w-[10px]">{name}</Body2>
      {!hideAvailable && (
        <Body2
          color="secondary"
          className="tw-shrink-0 tw-ml--1"
        >
          ({validMembers.length}/{members.length} {t("available")})
        </Body2>
      )}
      <div className="tw-whitespace-nowrap tw-w-4 tw-shrink-0 tw-ml-auto">
        <Checkbox
          mixed={mixed}
          checked={checked}
        />
      </div>
    </div>
  );
};

TeamOption.propTypes = {
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  ids: PropTypes.arrayOf(PropTypes.number).isRequired,
  selected: PropTypes.arrayOf(PropTypes.number).isRequired,
  members: PropTypes.arrayOf(PropTypes.number).isRequired,
  hideAvailable: PropTypes.bool,
};
